/**
 * RegExp to test a string for a ISO 8601 Date spec
 *  YYYY
 *  YYYY-MM
 *  YYYY-MM-DD
 *  YYYY-MM-DDThh:mmTZD
 *  YYYY-MM-DDThh:mm:ssTZD
 *  YYYY-MM-DDThh:mm:ss.sTZD
 * @see: https://www.w3.org/TR/NOTE-datetime
 * @type {RegExp}
 */
var ISO_8601 =
    /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i

/**
 * RegExp to test a string for a full ISO 8601 Date
 * Does not do any sort of date validation, only checks if the string is according to the ISO 8601 spec.
 *  YYYY-MM-DDThh:mm:ss
 *  YYYY-MM-DDThh:mm:ssTZD
 *  YYYY-MM-DDThh:mm:ss.sTZD
 * @see: https://www.w3.org/TR/NOTE-datetime
 * @type {RegExp}
 */
var ISO_8601_FULL =
    /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i

// Regex taken from https://stackoverflow.com/a/37563868/235276

function dateReviver(key: string, value: unknown) {
    if (isDateTypeKey(key)) {
        return convertStringToDate(value)
    }
    return value
}

const convertStringToDate = (value: unknown) => {
    if (
        typeof value === 'string' &&
        (ISO_8601.test(value) || ISO_8601_FULL.test(value))
    ) {
        return new Date(value)
    }
    return value
}

const isDateTypeKey = (key: string): boolean => {
    const dateKeysArray = [
        'dateOfTreatment',
        'dateOfImplantLoading',
        'dateOfSecondSurgery',
        'dateProductWasRemoved',
        'dateOfOccurrence',
    ]
    return dateKeysArray.includes(key)
}

export default dateReviver
